import { Injectable } from '@angular/core';
import { polygon as turfPolygon, intersect, booleanContains } from '@turf/turf'
import { Coordinate } from 'ol/coordinate';
import { Extent } from 'ol/extent';
import { Geometry, Polygon } from 'ol/geom';

@Injectable({
  providedIn: 'root'
})
export class GeometryUtilsService {

  constructor() { }

  /**
   * Radians to degrees conversion
   * @param radians angle in radians to converted
   * @returns Angle in degrees
   */
   rad2deg(radians: number): number{
    return radians * (180 / Math.PI);
  }

  /**
   * Degrees to radians conversion
   * @param degrees angle in degrees to converted
   * @returns Angle in radians
   */
  deg2rad(degrees: number): number{
    return (degrees * Math.PI) / 180;  
  }

  calculateCenter(geometry) {
    let center: number[], coordinates;
    let x = 0;
    let y = 0;
    let i = 0;
    coordinates = geometry.getCoordinates()[0].slice(1);
    coordinates.forEach((coordinate) => {
      x += coordinate[0];
      y += coordinate[1];
      i++;
    });
    center = [x / i, y / i];

    return {
      center: center,
      coordinates: coordinates
    };
  }

  /**
   * Checks whether polygonToCheck overlaps with any one of the polygon in listOfPolygons.
   * @param polygonToCheck The polygon whose geometry needs to be checked.
   * @param listOfPolygons The list of polygons the check is run against.
   * @returns true if polygonToCheck overlaps with any polygon from listOfPolygon, false otherwise
   */
  checkOverlaps(polygonToCheck: Coordinate[][], listOfPolygons: Coordinate[][][]) {
    const turfPolygonToCheck = turfPolygon(polygonToCheck);
    for (let item of listOfPolygons) {
      let turfItemPolygon = turfPolygon(item);
      if (intersect(turfPolygonToCheck, turfItemPolygon)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Checks whether polygonToCheck is completely contained inside candidate.
   * @param candidate The polygon the check is run against.
   * @param polygonToCheck The polygon whose geometry needs to be checked.
   * @returns true if polygonToCheck is completely contained inside candidate, false otherwise
   */
  checkContains(candidate: Coordinate[][], polygonToCheck: Coordinate[][]){
    const turfPolygonToCheck = turfPolygon(polygonToCheck);
    let turfCandidate = turfPolygon(candidate);
    if (booleanContains(turfPolygonToCheck, turfCandidate)) {
      return true;
    }
    return false;
  }

  clamp(num: number, min: number, max: number): number {
    return num <= min 
      ? min 
      : num >= max 
        ? max 
        : num
  }

  pointDistance(a: Array<number>, b: Array<number>): Array<number> {
    return [a[0] - b[0], a[1] - b[1]]
  }

  rectDistance(point: Array<number>, rect: Extent): Array<number> {
    let left = rect[0];
    let top = rect[1];
    let right = rect[2];
    let bottom = rect[3];

    let nearestX = this.clamp(point[0], left, right);
    let nearestY = this.clamp(point[1], top, bottom);

    let dx = point[0] - nearestX;
    let dy = point[1] - nearestY;

    return [dx, dy];
  }

  sqrDistance(point: Array<number>, rect: Extent): Array<number> {
    let rx = (rect[0] + rect[2]) / 2;
    let ry = (rect[1] + rect[3]) / 2;
    let rwidth = rect[2] - rect[0];
    let rheight = rect[3] - rect[1];

    let dx = Math.max(Math.abs(point[0] - rx) - rwidth / 2, 0);
    let dy = Math.max(Math.abs(point[1] - ry) - rheight / 2, 0);
    return [dx, dy];
}

}
